<template>
  <v-navigation-drawer
    v-model="drawer"
    permanent
    v-model:mini-variant="mini"  mini-variant-width="48px"
    :width="mini ? '48px' : '97.75%'" :height="height"
    class="grey lighten-3 mt-3 ml-3 rounded-lg rounded-r-0"
    style="z-index: 100; position: absolute"
  >
    <div class="d-flex nowrap">
      <div style="min-width: 48px">
        <v-btn
          icon
          color="grey lighten-3"
          class="d-flex justify-end secundary6--text mt-1"
          to="/pacientes/perfil"
        >
          <v-icon class="grey lighten-3" size="36">mdi-clipboard-account-outline</v-icon>
        </v-btn>
        <v-btn icon @click.stop="mini = !mini" class="mt-16 ml-1">
          <v-icon size="30">mdi-drag-vertical</v-icon>
        </v-btn>
      </div>
      <div class="mx-auto" style="min-height: 60; width: 1260px">
        <v-banner-line-data-patient />
        <v-row
          v-for="(form, formIdx) in coDateForm"
          :key="'form-' + formIdx"
          class="d-flex justify-start mt-6"
        >
          <v-col cols="4" class="pb-0 mb-0">
            <span class="text-primary font-weight-bold ml-3">{{ form.title }}</span>
          </v-col>
          <v-col cols="8" class="pb-0 mb-0"></v-col>
          <v-col cols="2"> </v-col>
          <v-col
            v-for="(field, fieldIdx) in form.evaluation"
            :key="'form-' + formIdx + '-field-' + fieldIdx"
            :cols="field.cols"
            :sm="field.sm"
            :md="field.md"
            :lg="field.lg"
            class="d-flex ml-4 pa-0"
          >
            <component
              :is="field.component"
              :type="field.type"
              :items="field.items"
              v-bind="{ ...field.props }"
              v-model="field.vModel"
            >
            </component>
          </v-col>
        </v-row>

        <v-row justify="start" class="mt-3 mb-8" wrap>
          <v-col cols="12" class="secundary--text font-weight-bold ml-3 py-0 mt-4">INDEX</v-col>

          <div class="ml-1">
            <v-col
              v-for="(anamI1, i1) in anamGroupShow.anamGroupI"
              :key="'groupI-' + i1"
              class="secundary--text text-body-2 ml-3 py-0 my-2"
            >
              <router-link
                class="secundary--text"
                :to="anamI1.to"
                style="text-decoration: none; color: inherit"
              >
                {{ anamI1.title }}
                <v-icon small v-if="anamI1.permission === false">mdi-lock-alert</v-icon>
              </router-link>

              <div
                v-for="(anamI1Sub1, i2) in anamI1.subtitle"
                :key="'groupI-' + i1 + '-sub1-' + i2"
                class="secundary--text ml-6 my-1 mt-3"
              >
                <router-link
                  class="secundary--text"
                  :to="anamI1Sub1.to"
                  style="text-decoration: none; color: inherit"
                >
                  {{ anamI1Sub1.title }}
                  <v-icon small v-if="anamI1Sub1.permission === false">mdi-lock-alert</v-icon>
                </router-link>

                <div
                  v-for="(anamI1Sub1Sub, i3) in anamI1Sub1.subtitle"
                  :key="'groupI-' + i1 + '-sub1-' + i2 + '-sub2-' + i3"
                  class="secundary--text ml-5 my-1"
                >
                  <router-link
                    class="secundary--text"
                    :to="anamI1Sub1Sub.to"
                    style="text-decoration: none; color: inherit"
                  >
                    {{ anamI1Sub1Sub.title }}
                    <v-icon small v-if="anamI1Sub1Sub.permission === false">mdi-lock-alert</v-icon>
                  </router-link>
                </div>
              </div>
            </v-col>
          </div>

          <v-divider vertical class="ml-13"></v-divider>

          <div>
            <v-col
              v-for="(anamII1, i1) in anamGroupShow.anamGroupII"
              :key="'groupII-' + i1"
              class="secundary--text text-body-2 ml-3 py-0 my-2 mb-8"
            >
              <router-link
                class="secundary--text"
                :to="anamII1.to"
                style="text-decoration: none; color: inherit"
              >
                {{ anamII1.title }}
                <v-icon small v-if="anamII1.permission === false">mdi-lock-alert</v-icon>
              </router-link>

              <div
                v-for="(anamII1Sub1, i2) in anamII1.subtitle"
                :key="'groupII-' + i1 + '-sub1-' + i2"
                class="secundary--text ml-6 my-1 mt-3"
              >
                <router-link
                  class="secundary--text"
                  :to="anamII1Sub1.to"
                  style="text-decoration: none; color: inherit"
                >
                  {{ anamII1Sub1.title }}
                  <v-icon small v-if="anamII1Sub1.permission === false">mdi-lock-alert</v-icon>
                </router-link>

                <div
                  v-for="(anamII1Sub1Sub, i3) in anamII1Sub1.subtitle"
                  :key="'groupII-' + i1 + '-sub1-' + i2 + '-sub2-' + i3"
                  class="secundary--text ml-5 my-1"
                >
                  <router-link
                    class="secundary--text"
                    :to="anamII1Sub1Sub.to"
                    style="text-decoration: none; color: inherit"
                  >
                    {{ anamII1Sub1Sub.title }}
                    <v-icon small v-if="anamII1Sub1Sub.permission === false">mdi-lock-alert</v-icon>
                  </router-link>
                </div>
              </div>
            </v-col>

            <v-col
              v-for="(anamIII1, i1) in anamGroupShow.anamGroupIII"
              :key="'groupIII-' + i1"
              class="secundary--text text-body-2 ml-sm-4 ml-lg-8 pt-2"
            >
              <router-link
                class="secundary--text"
                :to="anamIII1.to"
                style="text-decoration: none; color: inherit"
              >
                {{ anamIII1.title }}
                <v-icon small v-if="anamIII1.permission === false">mdi-lock-alert</v-icon>
              </router-link>

              <div
                v-for="(anamIII1Sub1, i2) in anamIII1.subtitle"
                :key="'groupIII-' + i1 + '-sub1-' + i2"
                class="secundary--text ml-6 py-0 my-4"
              >
                <router-link
                  class="secundary--text"
                  :to="anamIII1Sub1.to"
                  style="text-decoration: none; color: inherit"
                >
                  {{ anamIII1Sub1.title }}
                  <v-icon small v-if="anamIII1Sub1.permission === false">mdi-lock-alert</v-icon>
                </router-link>

                <div
                  v-for="(anamIII1Sub2, i3) in anamIII1Sub1.subtitle2"
                  :key="'groupIII-' + i1 + '-sub1-' + i2 + '-sub2-' + i3"
                  class="secundary--text ml-6 my-1"
                >
                  <router-link
                    class="secundary--text"
                    :to="anamIII1Sub2.to"
                    style="text-decoration: none; color: inherit"
                  >
                    {{ anamIII1Sub2.title }}
                    <v-icon small v-if="anamIII1Sub2.permission === false">mdi-lock-alert</v-icon>
                  </router-link>
                </div>
              </div>
            </v-col>
          </div>
        </v-row>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import VBannerLineDataPatient from '@/components/base/VBannerLineDataPatient.vue';

export default {
  name: 'VNavDrawAnam',
  components: {
    VBannerLineDataPatient,
  },
  props: ['schemaNavIdent', 'coDateForm', 'anamIndex', 'anamGroupShow'],
  data() {
    return {
      drawer: true,
      mini: true,
    };
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 582;
        case 'sm':
          return 460;
        case 'md':
          return 460;
        case 'lg':
          return 460;
        case 'xl':
          return 460;
        default:
          return 460;
      }
    },
  },
};
</script>

<style>
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  overflow: hidden;
}
</style>
